const style = `
  .payment-method-collection:last-of-type {
    margin-bottom: 9px;
  }
`

export default style
